var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm.personList.length > 0
        ? _c("div", { staticClass: "tool-list" }, [
            _c("span", { staticStyle: { "margin-right": "15px" } }, [
              _c("strong", [
                _vm._v("本次搜尋筆數：" + _vm._s(_vm.totalPerson) + " 筆"),
              ]),
            ]),
            _c(
              "button",
              {
                staticClass: "btn btn-info mr-2",
                attrs: { type: "button" },
                on: { click: _vm.exportTalent },
              },
              [_vm._v(" 匯出 ")]
            ),
            _c("div", { staticClass: "tool-list-about-card" }, [
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "block" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "block"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "grid-outline" },
                  }),
                ],
                1
              ),
              _c(
                "span",
                {
                  class: { active: _vm.gridStyle == "list" },
                  on: {
                    click: function ($event) {
                      _vm.gridStyle = "list"
                    },
                  },
                },
                [
                  _c("eva-icon", {
                    attrs: { fill: "#000", name: "list-outline" },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm.doSearch && _vm.personList.length === 0
        ? _c(
            "div",
            { staticStyle: { "text-align": "center", "padding-top": "100px" } },
            [
              _c("img", {
                staticStyle: {
                  width: "250px",
                  opacity: "0.5",
                  "background-color": "#eaeaea",
                  "border-radius": "50%",
                  "margin-bottom": "20px",
                },
                attrs: { src: require("@/assets/img/no_record.png"), alt: "" },
              }),
              _c("br"),
              _vm._v(" 查無資料 "),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "person-card-list",
          class: {
            "list-style": _vm.gridStyle == "list",
            "block-style": _vm.gridStyle == "block",
          },
        },
        _vm._l(_vm.personList, function (person, index) {
          return _c(
            "div",
            { key: index, staticClass: "person-card infinite-list-item" },
            [
              _c("PersonCard", {
                ref: "personCard",
                refInFor: true,
                attrs: { showCheckbox: true, person: person },
                on: { updatePersonList: _vm.updatePersonList },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "middleContent",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "ul",
                            {
                              staticStyle: {
                                height: "300px",
                                "font-size": "15px",
                                "line-height": "26px",
                              },
                            },
                            [
                              _c("li", { staticClass: "mt-1" }, [
                                _vm._v("學歷"),
                              ]),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(props.Education[0]),
                                },
                              }),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(props.Education[1]),
                                },
                              }),
                              _c("li", { staticClass: "mt-1" }, [
                                _vm._v(
                                  "工作經歷／總年資" +
                                    _vm._s(props.TotalSeniority) +
                                    "年"
                                ),
                              ]),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(props.WorkExperience[0]),
                                },
                              }),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(props.WorkExperience[1]),
                                },
                              }),
                              _c("li", [
                                _vm._v(
                                  "履歷來源 " + _vm._s(props.ResumeSource)
                                ),
                              ]),
                              _c("li", { staticClass: "mt-1" }, [
                                _vm._v(
                                  " 最後更新時間 " +
                                    _vm._s(
                                      _vm.$common.dateTimeFormatter(
                                        props.UpdateTime
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _c("li", { staticClass: "mt-1" }, [
                                _vm._v(
                                  " 最新應徵職缺 " +
                                    _vm._s(props.LatestJobApply) +
                                    "／" +
                                    _vm._s(props.LatestStatus) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "buttonGroup",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "el-dropdown",
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "el-dropdown-link",
                                  attrs: { type: "button" },
                                },
                                [
                                  _vm._v(" 檢視資訊"),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right",
                                  }),
                                ]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showDetailModal(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視履歷 ")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.showProgressRecord(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" 檢視歷程 ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.showContactInfo(props)
                                },
                              },
                            },
                            [_vm._v(" 聯繫資訊 ")]
                          ),
                          _c(
                            "button",
                            {
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.showJobIntention(props)
                                },
                              },
                            },
                            [_vm._v(" 職缺意願 ")]
                          ),
                          props.BlacklistEver
                            ? _c(
                                "button",
                                {
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showBlackHistory(props)
                                    },
                                  },
                                },
                                [_vm._v(" 黑名單歷程 ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm.personList.length > 0
        ? _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next, jumper",
              total: _vm.totalPerson,
              "page-size": 9,
            },
            on: {
              "current-change": _vm.changePage,
              "size-change": _vm.changePage,
            },
          })
        : _vm._e(),
      _c("ActionBar", {
        attrs: {
          show: _vm.showActionBar,
          totalPerson: _vm.totalPerson,
          selectedCardList: _vm.choosePersonList,
        },
        on: {
          showActionBar: function ($event) {
            _vm.showActionBar = !_vm.showActionBar
          },
          selectAllCards: _vm.selectAllCards,
          clearSelectCard: _vm.clearSelectCard,
        },
        scopedSlots: _vm._u([
          {
            key: "button",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.openActionModal({ action: "matchJob" }),
                          (_vm.showActionBar = false)
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "brush-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("轉入職缺")]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.openActionModal({ action: "shareResume" }),
                          (_vm.showActionBar = false)
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "paper-plane-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("分享履歷")]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    staticStyle: { background: "red" },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.openActionModal({ action: "addBacklist" }),
                          (_vm.showActionBar = false)
                      },
                    },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "minus-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("加入黑名單")]),
                  ],
                  1
                ),
                _c(
                  "button",
                  {
                    staticClass: "action-btn",
                    staticStyle: { background: "green" },
                    attrs: { type: "button" },
                    on: { click: _vm.blacklistRemoval },
                  },
                  [
                    _c("eva-icon", {
                      attrs: { name: "undo-outline", fill: "#FFF" },
                    }),
                    _c("span", [_vm._v("解除黑名單")]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "shareResumeModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("span", [_vm._v("分享履歷")]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "modal-body" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("收件者："),
                              ]),
                              _c("ValidationProvider", {
                                ref: "ReceiverIds",
                                attrs: { rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("v-select", {
                                            attrs: {
                                              options: _vm.supervisorOptions,
                                              multiple: "",
                                              label: "Name",
                                              placeholder: "請選擇",
                                              reduce: (ReceiverIds) =>
                                                ReceiverIds.Guid,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "option",
                                                  fn: function (option) {
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(option.Name) +
                                                          " "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: _vm.ReceiverIds,
                                              callback: function ($$v) {
                                                _vm.ReceiverIds = $$v
                                              },
                                              expression: "ReceiverIds",
                                            },
                                          }),
                                          errors[0]
                                            ? _c(
                                                "p",
                                                { staticClass: "text-danger" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(errors[0]) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _c("img", {
                                staticClass: "job-position",
                                attrs: {
                                  src: require("@/assets/img/job_position.png"),
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showActionBar = true
                                  },
                                },
                              },
                              [_vm._v(" 取消 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "submit" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.shareResume)
                                  },
                                },
                              },
                              [_vm._v(" 確定 ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "matchJobModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-centered" },
            [
              _c(
                "div",
                { staticClass: "modal-content" },
                [
                  _c("ValidationObserver", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ handleSubmit }) {
                          return [
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return handleSubmit(_vm.matchJobManagement)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "modal-header" }, [
                                  _c("span", [_vm._v("轉入職缺")]),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "modal-body" },
                                  [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("選擇職缺："),
                                    ]),
                                    _c("ValidationProvider", {
                                      ref: "matchDemandId",
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: true,
                                                      "value-key":
                                                        "ManpowerDemandNo",
                                                      placeholder: "請選擇",
                                                    },
                                                    model: {
                                                      value: _vm.matchDemandId,
                                                      callback: function ($$v) {
                                                        _vm.matchDemandId = $$v
                                                      },
                                                      expression:
                                                        "matchDemandId",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.openingOptions,
                                                    function (opening) {
                                                      return _c("el-option", {
                                                        key: opening.ManpowerDemandNo,
                                                        staticStyle: {
                                                          width: "760px",
                                                        },
                                                        attrs: {
                                                          label: `${opening.ManpowerDemandNo}-${opening.ManpowerDemandName}`,
                                                          value:
                                                            opening.ManpowerDemandNo,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _c("img", {
                                      staticClass: "job-position",
                                      attrs: {
                                        src: require("@/assets/img/job_position.png"),
                                        alt: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "modal-footer" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: {
                                        type: "button",
                                        "data-dismiss": "modal",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showActionBar = true
                                        },
                                      },
                                    },
                                    [_vm._v(" 取消 ")]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success",
                                      attrs: { type: "submit" },
                                    },
                                    [_vm._v("確定")]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "blacklistModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ handleSubmit }) {
                        return [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("span", [_vm._v("加入黑名單")]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "div",
                              { staticClass: "form-group form" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 請輸入原因 "),
                                ]),
                                _c("ValidationProvider", {
                                  ref: "backlistReason",
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.backlistReason,
                                                  expression: "backlistReason",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                rows: "5",
                                              },
                                              domProps: {
                                                value: _vm.backlistReason,
                                              },
                                              on: {
                                                compositionstart: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = true
                                                },
                                                compositionend: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = false
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.backlistReason =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showActionBar = true
                                  },
                                },
                              },
                              [_vm._v(" 取消 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.addBlacklist)
                                  },
                                },
                              },
                              [_vm._v(" 加入 ")]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "blackHistoryModal",
            tabindex: "-1",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-xl" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(0),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.blackHistoryData },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "Status", label: "狀態" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "Reason", label: "黑名單原因" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "CreateTime",
                            formatter: _vm.dateFormatter,
                            label: "建立時間",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "CreateUser", label: "建立者" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._m(1),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "transition",
        {
          attrs: {
            name: "custom-classes-transition",
            "enter-active-class": "animated bounceInLeft",
            "leave-active-class": "animated bounceOutRight",
          },
        },
        [
          _vm.isShowDetail
            ? _c("div", { staticClass: "detail-modal" }, [
                _c("div", { staticClass: "detail-modal-inner" }, [
                  _c("div", { staticClass: "menu" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            ;(_vm.detailCurrentPage = 0),
                              (_vm.ResumeType = "IDL")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" IDL 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            ;(_vm.detailCurrentPage = 0),
                              (_vm.ResumeType = "DL")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("eva-icon", {
                              attrs: { name: "person-outline", fill: "#FFF" },
                            }),
                            _vm._v(" DL 履歷 "),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "close-show-detail",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.isShowDetail = !_vm.isShowDetail
                          },
                        },
                      },
                      [
                        _c("eva-icon", {
                          attrs: {
                            name: "close-circle",
                            fill: "#FFF",
                            width: "50",
                            height: "50",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "page-wrap" },
                    [
                      _c(
                        "transition",
                        {
                          attrs: {
                            name: "custom-classes-transition",
                            "enter-active-class": "animated flipInY",
                          },
                        },
                        [
                          _vm.detailCurrentPage === 0
                            ? _c("perfect-scrollbar", { staticClass: "page" }, [
                                _c(
                                  "section",
                                  { staticClass: "page-inner" },
                                  [
                                    _c("div", { staticClass: "title" }, [
                                      _c("div", { staticClass: "item" }, [
                                        _vm._v("履歷"),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "item text-right" },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-primary btn-sm",
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$store.commit(
                                                    "OpenResumeCategoryModal",
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 分類 ")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-primary btn-sm",
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$common.downloadSummaryPDF(
                                                    _vm.ResumeId
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 簡歷 ")]
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-primary btn-sm",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$common.downloadResumePDF(
                                                    _vm.ResumeType,
                                                    _vm.ResumeId
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(" 下載 PDF ")]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm.ResumeType === "IDL"
                                      ? _c("IdlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                    _vm.ResumeType === "DL"
                                      ? _c("DlResume", {
                                          attrs: {
                                            ResumeId: _vm.ResumeId,
                                            ResumeType: _vm.ResumeType,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("ResumeTagModal", { attrs: { ResumeId: _vm.ResumeId } }),
      _c("ContactInfoModal", { attrs: { personData: _vm.interviewee } }),
      _c("ResponseDataModal", {
        attrs: {
          successfulList: _vm.successMessage,
          failedList: _vm.failMessage,
        },
        scopedSlots: _vm._u(
          [
            _vm.messageType === "job"
              ? {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-danger btn-sm",
                          staticStyle: {
                            "margin-top": "10px",
                            "margin-left": "10px",
                            "margin-bottom": "-10px",
                          },
                          attrs: { type: "button" },
                          on: { click: _vm.goToJobListPage },
                        },
                        [_vm._v(" 點此進入職缺 ")]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c("JobIntentionModal", { attrs: { personData: _vm.interviewee } }),
      _c("ProgressRecordModal", {
        attrs: { Name: _vm.Name, UserId: _vm.UserId, Email: _vm.Email },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", [_vm._v("黑名單歷程")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v(" 關閉 ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }